<template>
  <div
    :class="['dr-wrapper', { 'dr-is-selected-widget' : isSelected, 'dr-editable':!readonly, 'editor-mode': this.isInEditorMode}]"
  >
    <!--  Отрисовка кнопки удаления для колонок в панели свойств -->
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="deleteComponent">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>
    <slot />
    <div
      @click.stop="selectComponent(model)"
      @contextmenu="onShowContextMenu"
      class="dr-wrapper-overlay"
    ></div>
    <!-- Контекстное меню -->
    <widgets-context-menu
      v-if="isInEditorMode"
      v-model="showContextMenu"
      :widgetModel="model"
      :x="x"
      :y="y"
      :snippetCreatable="!isInSnippetEditor"
      @createSnippet="onCreateSnippet"
      @deleteComponent="deleteComponent"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
  </div>

</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'

export default {
  mixins: [baseMixin, contextMenuMixin],
  methods: {
    deleteComponent() {
      this.$emit('deleteComponent', this.model)
    }
  }
}
</script>

<style lang="scss">
// @import '../../scss/tooltips.scss';
.dr-wrapper {
  position: relative;
}
.dr-wrapper-overlay {
  display: none;
}

.editor-mode {
  padding: 5px;
  margin: 5px;
  &.dr-editable:hover {
    outline: 2px solid rgba(255, 166, 0, 0.452);
    outline-offset: -2px;
  }

  .dr-wrapper-overlay {
    display: block;

    position: absolute;
    left: 5px;
    right: 5px;
    top: 5px;
    bottom: 5px;
  }

  &.dr-is-selected-widget {
    outline: 2px solid #ffa500;
    outline-offset: -2px;
  }
}
</style>
